<div class="alert-wrapper" [ngClass]="alertClass">
    <span class="{{ icon }}"></span>
    <p class="alert-title">{{ message }}</p>
</div>
